(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["yg-image-multi-column"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    class YGSwiperCard extends YGUtils {
      constructor() {
        super();
        this.swiper = null;
      }
      connectedCallback() {
        // 避免多次初始化
        if (this.swiper) return;

        this.swiper = this.initSwiper(this);
      }
    }
    if (!customElements.get('yg-swiper-card')) {
      customElements.define('yg-swiper-card', YGSwiperCard);
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["yg-layer-animation"] && !Shopify.designMode) return;
  try {
    
  (() => {
    class YGLayerAnimation extends HTMLElement {
      constructor() {
        super();
        this.currentStep = 0;
        this.hasExpanded = false;
        this.resizeRafId = null;
        this.panelTimer = null;
        this.expandDelayTimer = null;
        this.expandObserver = null;
        this.positionSyncTimers = [];
        this.lastMeasuredWidth = 0;
        this.cachedLayerHeights = [];
        this.boundOnResize = this.onResize.bind(this);
        this.boundOnInteraction = this.onInteraction.bind(this);
        this.boundOnKeydown = this.onKeydown.bind(this);
      }

      connectedCallback() {
        this.layers = Array.from(this.querySelectorAll('.yg-layer-animation__layer'));
        this.templates = Array.from(this.querySelectorAll('template[data-index]'));
        this.layersContainer = this.querySelector('[data-role="layers"]');
        this.infoPanel = this.querySelector('[data-role="panel"]');
        this.stepBadge = this.querySelector('[data-role="step"]');
        this.triggerContainer = this.closest('.shopify-section') || this.closest('.section') || this;

        if (!this.layers.length || !this.layersContainer || !this.infoPanel) {
          return;
        }

        this.addEventListener('click', this.boundOnInteraction);
        this.addEventListener('keydown', this.boundOnKeydown);
        window.addEventListener('resize', this.boundOnResize);

        this.observeLayerImages();
        this.setStep(0, true);
        this.updateLayerPositions(true);
        this.setupExpandObserver();

        requestAnimationFrame(() => {
          this.updateLayerPositions(true);
          this.updateExpandStateByScroll();
        });
      }

      disconnectedCallback() {
        this.removeEventListener('click', this.boundOnInteraction);
        this.removeEventListener('keydown', this.boundOnKeydown);
        window.removeEventListener('resize', this.boundOnResize);
        this.teardownExpandObserver();

        if (this.resizeRafId) {
          cancelAnimationFrame(this.resizeRafId);
          this.resizeRafId = null;
        }

        if (this.panelTimer) {
          clearTimeout(this.panelTimer);
          this.panelTimer = null;
        }

        if (this.expandDelayTimer) {
          clearTimeout(this.expandDelayTimer);
          this.expandDelayTimer = null;
        }

        this.clearPositionSyncTimers();
      }

      get isMobile() {
        return window.matchMedia('(max-width: 699px)').matches;
      }

      observeLayerImages() {
        this.layers.forEach((layer) => {
          const image = layer.querySelector('img');
          if (!image) {
            return;
          }

          const refreshPosition = () => {
            this.lastMeasuredWidth = 0;
            this.updateLayerPositions(true);
          };

          if (image.complete) {
            if (typeof image.decode === 'function') {
              image
                .decode()
                .catch(() => {})
                .then(refreshPosition);
            } else {
              refreshPosition();
            }
          } else {
            image.addEventListener('load', refreshPosition, { once: true });
          }
        });
      }

      onInteraction(event) {
        const actionButton = event.target.closest('[data-action]');

        if (actionButton && this.contains(actionButton)) {
          if (actionButton.dataset.action === 'prev') {
            this.setStep(this.currentStep - 1);
          }

          if (actionButton.dataset.action === 'next') {
            this.setStep(this.currentStep + 1);
          }

          return;
        }

        if (!this.hasExpanded) {
          return;
        }

        const layer = event.target.closest('.yg-layer-animation__layer');

        if (layer && this.contains(layer)) {
          this.setStep(Number(layer.dataset.index));
        }
      }

      onKeydown(event) {
        if (!this.contains(document.activeElement)) {
          return;
        }

        if (event.key === 'ArrowLeft' || event.key === 'ArrowUp') {
          event.preventDefault();
          this.setStep(this.currentStep - 1);
        }

        if (event.key === 'ArrowRight' || event.key === 'ArrowDown') {
          event.preventDefault();
          this.setStep(this.currentStep + 1);
        }
      }

      onResize() {
        if (this.resizeRafId !== null) {
          return;
        }

        this.resizeRafId = requestAnimationFrame(() => {
          this.lastMeasuredWidth = 0;
          this.updateLayerPositions(true);
          this.resizeRafId = null;
        });
      }

      setupExpandObserver() {
        this.teardownExpandObserver();

        if (this.hasExpanded || typeof IntersectionObserver === 'undefined') {
          this.updateExpandStateByScroll();
          return;
        }

        this.expandObserver = new IntersectionObserver(
          (entries) => {
            const entry = entries[0];

            if (!entry || this.hasExpanded) {
              return;
            }

            if (entry.isIntersecting) {
              this.scheduleExpand();
            } else {
              this.cancelScheduledExpand();
            }
          },
          {
            rootMargin: '-18% 0px -22% 0px',
            threshold: [0, 0.01, 0.15, 0.3],
          }
        );

        this.expandObserver.observe(this.triggerContainer);
      }

      teardownExpandObserver() {
        if (!this.expandObserver) {
          return;
        }

        this.expandObserver.disconnect();
        this.expandObserver = null;
      }

      scheduleExpand() {
        if (this.hasExpanded || this.expandDelayTimer !== null) {
          return;
        }

        this.expandDelayTimer = window.setTimeout(() => {
          this.expandDelayTimer = null;

          if (this.hasExpanded || !this.isTriggerContainerVisible()) {
            return;
          }

          this.setExpanded(true);
        }, 500);
      }

      cancelScheduledExpand() {
        if (this.expandDelayTimer === null) {
          return;
        }

        clearTimeout(this.expandDelayTimer);
        this.expandDelayTimer = null;
      }

      updateLayerPositions(force = false) {
        const containerWidth = Math.round(this.layersContainer.clientWidth);

        if (containerWidth <= 0) {
          return;
        }

        let heights = this.cachedLayerHeights;

        if (force || this.lastMeasuredWidth !== containerWidth || heights.length !== this.layers.length) {
          heights = this.layers.map((layer) => {
            const image = layer.querySelector('img');

            if (image && image.naturalWidth > 0 && image.naturalHeight > 0) {
              return (containerWidth * image.naturalHeight) / image.naturalWidth;
            }

            return layer.getBoundingClientRect().height;
          });

          this.cachedLayerHeights = heights;
          this.lastMeasuredWidth = containerWidth;
        }

        if (!heights.length || heights.some((height) => height === 0)) {
          return;
        }

        const gap = this.isMobile ? 12 : 20;
        let expandedCursor = 0;

        const expandedPositions = heights.map((height) => {
          const top = expandedCursor;
          expandedCursor += height + gap;
          return top;
        });

        const expandedTotalHeight = expandedCursor - gap;

        const compressedHeights = heights.map((height, index) => {
          const ratio = this.isMobile
            ? index === 4
              ? 0.28
              : index === 0
              ? 0.18
              : 0.14
            : index === 4
            ? 0.32
            : index === 0
            ? 0.22
            : 0.18;

          const maxVisible = this.isMobile ? (index === 4 ? 44 : 18) : index === 4 ? 60 : 26;

          return Math.max(10, Math.min(height * ratio, maxVisible));
        });

        const collapsedTotalHeight = compressedHeights.reduce((sum, height) => sum + height, 0);
        let collapsedCursor = Math.max(0, (expandedTotalHeight - collapsedTotalHeight) / 2);

        this.layers.forEach((layer, index) => {
          layer.style.setProperty('--expanded-y', `${expandedPositions[index]}px`);
          layer.style.setProperty('--collapsed-y', `${collapsedCursor}px`);
          layer.style.setProperty('--explode-progress', this.classList.contains('is-expanded') ? '1' : '0');
          layer.style.zIndex = String(this.layers.length - index);
          collapsedCursor += compressedHeights[index];
        });

        this.layersContainer.style.height = `${expandedTotalHeight}px`;
      }

      updateExpandStateByScroll() {
        if (this.hasExpanded) {
          return;
        }

        if (this.isTriggerContainerVisible()) {
          this.scheduleExpand();
        } else {
          this.cancelScheduledExpand();
        }
      }

      isTriggerContainerVisible() {
        const rect = this.triggerContainer.getBoundingClientRect();
        const viewportHeight = window.innerHeight || document.documentElement.clientHeight;

        if (viewportHeight <= 0 || rect.height <= 0) {
          return false;
        }

        const enterLine = viewportHeight * 0.62;
        const exitLine = viewportHeight * 0.28;
        const visibleTop = Math.max(rect.top, 0);
        const visibleBottom = Math.min(rect.bottom, viewportHeight);
        const visibleHeight = visibleBottom - visibleTop;

        return rect.top < enterLine && rect.bottom > exitLine && visibleHeight > viewportHeight * 0.28;
      }

      setExpanded(isExpanded) {
        if (!isExpanded && this.hasExpanded) {
          return;
        }

        if (isExpanded) {
          this.cancelScheduledExpand();
          this.teardownExpandObserver();
          this.hasExpanded = true;
        }

        this.classList.toggle('is-expanded', isExpanded);
        this.classList.toggle('is-collapsed', !isExpanded);

        this.layers.forEach((layer) => {
          layer.style.setProperty('--explode-progress', isExpanded ? '1' : '0');
        });

        this.schedulePositionSync();
      }

      clearPositionSyncTimers() {
        if (!this.positionSyncTimers.length) {
          return;
        }

        this.positionSyncTimers.forEach((timer) => {
          clearTimeout(timer);
        });
        this.positionSyncTimers = [];
      }

      schedulePositionSync() {
        this.clearPositionSyncTimers();

        const syncDelays = [0, 80, 180, 320, 520];
        this.positionSyncTimers = syncDelays.map((delay) =>
          window.setTimeout(() => {
            this.lastMeasuredWidth = 0;
            this.updateLayerPositions(true);
          }, delay)
        );
      }

      setStep(step, skipAnimation = false) {
        const nextStep = Math.max(0, Math.min(this.layers.length - 1, step));
        this.currentStep = nextStep;

        this.layers.forEach((layer, index) => {
          layer.classList.toggle('is-active', index === this.currentStep);
        });

        if (this.stepBadge) {
          this.stepBadge.textContent = String(this.currentStep + 1);
        }

        this.updateNavState();
        this.renderPanel(skipAnimation);
      }

      updateNavState() {
        const isFirst = this.currentStep === 0;
        const isLast = this.currentStep === this.layers.length - 1;

        this.querySelectorAll('[data-action="prev"]').forEach((button) => {
          button.disabled = isFirst;
        });

        this.querySelectorAll('[data-action="next"]').forEach((button) => {
          button.disabled = isLast;
        });
      }

      renderPanel(skipAnimation = false) {
        const template = this.templates.find(
          (panelTemplate) => Number(panelTemplate.dataset.index) === this.currentStep
        );

        if (!template) {
          return;
        }

        this.infoPanel.innerHTML = template.innerHTML;

        if (!skipAnimation) {
          const detailWrap = this.infoPanel.querySelector('.yg-layer-animation__detail-wrap');
          if (detailWrap) {
            detailWrap.classList.add('is-fade-in');
          }
        }
      }
    }

    if (!customElements.get('yg-layer-animation')) {
      customElements.define('yg-layer-animation', YGLayerAnimation);
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["yg-multi-column-switcher"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    class YGSwiperCard extends YGUtils {
      constructor() {
        super();
        this.swiper = null;
      }
      connectedCallback() {
        // 避免多次初始化
        if (this.swiper) return;

        this.swiper = this.initSwiper(this);
      }
    }
    if (!customElements.get('yg-swiper-card')) {
      customElements.define('yg-swiper-card', YGSwiperCard);
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["yg-multi-column"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    class YGSwiperCard extends YGUtils {
      constructor() {
        super();
        this.swiper = null;
      }
      connectedCallback() {
        // 避免多次初始化
        if (this.swiper) return;

        this.swiper = this.initSwiper(this);
      }
    }
    if (!customElements.get('yg-swiper-card')) {
      customElements.define('yg-swiper-card', YGSwiperCard);
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["yg-product-multi-column"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    class YGSwiperCard extends YGUtils {
      constructor() {
        super();
        this.swiper = null;
      }
      connectedCallback() {
        // 避免多次初始化
        if (this.swiper) return;

        this.swiper = this.initSwiper(this);
      }
    }
    if (!customElements.get('yg-swiper-card')) {
      customElements.define('yg-swiper-card', YGSwiperCard);
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["yg-timeline-image"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    class YGIimelineSwiper extends HTMLElement {
      constructor() {
        super();
        this.swiperInstance = null;
      }

      connectedCallback() {
        this.initSwiper();
        this.initTimelineInteraction();
      }

      disconnectedCallback() {
        if (this.swiperInstance) {
          this.swiperInstance.destroy(true, true);
          this.swiperInstance = null;
        }
      }

      initSwiper() {
        // 初始化图片 swiper
        this.imagesSwiperEl = this.querySelector('.yg-timeline-images-swiper');
        this.contentSwiperEl = this.querySelector('.yg-timeline-swiper');
        this.prevBtn = this.querySelector('.swiper-button-prev');
        this.nextBtn = this.querySelector('.swiper-button-next');

        // 创建图片 swiper 实例
        this.imagesSwiperInstance = new Swiper(this.imagesSwiperEl, {
          spaceBetween: 0,
          slidesPerView: 1,
          effect: 'fade',
        });

        // 创建内容 swiper 实例
        this.contentSwiperInstance = new Swiper(this.contentSwiperEl, {
          spaceBetween: 12,
          slidesPerView: 1,
          breakpoints: {
            700: {
              slidesPerView: 1,
              spaceBetween: 24,
            },
          },
          navigation: {
            nextEl: this.nextBtn,
            prevEl: this.prevBtn,
          },
          pagination: {
            el: '.swiper-pagination',
            type: 'progressbar',
          },
          controller: {
            control: this.imagesSwiperInstance,
          },
        });

        // 设置双向控制
        this.imagesSwiperInstance.controller.control = this.contentSwiperInstance;
      }
    }

    if (!customElements.get('yg-timeline-swiper')) {
      customElements.define('yg-timeline-swiper', YGIimelineSwiper);
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["yg-video-list"] && !Shopify.designMode) return;
  try {
    
  class YGVideoList extends YGUtils {
    constructor() {
      super();
      this.playVideo = this.playVideoFn.bind(this);
      this.handleSlideClick = this.handleSlideClickFn.bind(this);
      this.updateVideoProgress = this.updateVideoProgressFn.bind(this);
      this.currentPlayVideo = null;
      this.totalSlides = parseInt(this.dataset.totalSlides) || 1;
    }

    get videoList() {
      return this.querySelectorAll('yg-video.yg-video-box');
    }

    get currentVideo() {
      return this.querySelector('.swiper-slide-active yg-video.yg-video-box');
    }

    get swiperProgressBar() {
      return this.querySelector('.yg-swiper-progress-bar');
    }

    connectedCallback() {
      this.swiper = this.initSwiper(this);

      // 点击播放事件
      this.querySelectorAll('.swiper-slide').forEach((slide) => {
        slide.addEventListener('click', this.handleSlideClick);
      });

      // 监听 swiper 滑动更新进度条
      this.swiper.on('slideChange', () => {
        this.updateSwiperProgress();
      });

      window.addEventListener('resize', () => {
        this.initProgressContainer();
      });

      this.swiper.on('slideChangeTransitionEnd', () => {
        // 切换后暂停之前的视频
        this.pauseAllVideos();
      });

      // 默认播放第一个视频
      this.initFirstVideo();

      // 初始化 swiper 进度条
      this.updateSwiperProgress();
      this.initProgressContainer();
    }

    initFirstVideo() {
      // 延迟执行，确保 DOM 已经渲染完成
      setTimeout(() => {
        const firstSlide = this.querySelector('.swiper-slide[data-slide-index="0"]');
        const firstVideo = firstSlide?.querySelector('yg-video.yg-video-box');
        if (firstVideo) {
          this.playVideoFn({ currentTarget: firstVideo });
        }
      }, 500);
    }

    handleSlideClickFn(event) {
      // 阻止点击产品链接时触发播放
      if (event.target.closest('.yg-video-item-product')) {
        return;
      }

      // 获取点击的 video 元素
      const slide = event.currentTarget;
      let video = slide.querySelector('yg-video.yg-video-box'); // 默认查找 yg-video

      // 如果找到了视频元素，进行播放或暂停的处理
      if (video) {
        // 如果点击的是当前正在播放的视频，则暂停/播放切换
        if (this.currentPlayVideo === video) {
          const videoElement = video.querySelector('video');
          if (videoElement) {
            if (videoElement.paused || event.target.closest('.yg-play-video')) {
              video.playVideo();
              slide.classList.add('current-play');
            } else {
              video.pauseVideo();
              slide.classList.remove('current-play');
            }
          }
        } else {
          // 否则播放新视频
          this.playVideoFn({ currentTarget: video });
        }
      }
    }

    pauseAllVideos() {
      this.videoList.forEach((v) => {
        v.pauseVideo();
        const slide = v.closest('.swiper-slide');
        if (slide) {
          slide.classList.remove('current-play');
          const progressBar = slide.querySelector('.yg-video-progress-bar');
          if (progressBar) {
            progressBar.style.width = '0%';
          }
        }
      });
    }

    playVideoFn(event) {
      let video = event.currentTarget || event.target || this.currentVideo;

      // 如果点击的是当前视频且视频已经暂停，恢复播放
      if (this.currentPlayVideo === video) {
        const videoElement = video.querySelector('video');
        if (videoElement && videoElement.paused) {
          video.playVideo(); // 恢复播放
          const slide = video.closest('.swiper-slide');
          slide.classList.add('current-play');
        }
        return; // 退出，不要继续执行其他逻辑
      }

      // 暂停所有视频
      this.pauseAllVideos();

      this.currentPlayVideo = video;

      if (video && typeof video.playVideo === 'function') {
        video.playVideo();
        const slide = video.closest('.swiper-slide');
        slide.classList.add('current-play');

        // 绑定视频进度更新事件
        this.bindVideoProgressEvents(video);
      }
    }

    bindVideoProgressEvents(ygVideo) {
      const videoElement = ygVideo.querySelector('video');
      if (!videoElement) return;

      const slide = ygVideo.closest('.swiper-slide');
      const progressBar = slide.querySelector('.yg-video-progress-bar');

      // 移除之前的事件监听器
      videoElement.removeEventListener('timeupdate', this.updateVideoProgress);
      videoElement.removeEventListener('ended', this.handleVideoEnded);

      // 添加新的事件监听器
      const updateProgress = () => {
        if (progressBar && videoElement.duration) {
          const progress = (videoElement.currentTime / videoElement.duration) * 100;
          progressBar.style.width = `${progress}%`;
        }
      };

      const handleEnded = () => {
        // 视频播放完毕后，播放下一个
        if (this.swiper && !this.swiper.isEnd) {
          this.swiper.slideNext();
          setTimeout(() => {
            const nextVideo = this.currentVideo;
            if (nextVideo) {
              this.playVideoFn({ currentTarget: nextVideo });
            }
          }, 300);
        } else {
          // 如果是最后一个，重置进度条
          if (progressBar) {
            progressBar.style.width = '0%';
          }
        }
      };

      videoElement.addEventListener('timeupdate', updateProgress);
      videoElement.addEventListener('ended', handleEnded);

      // 存储引用以便后续移除
      this._currentUpdateProgress = updateProgress;
      this._currentHandleEnded = handleEnded;
    }

    initProgressContainer() {
      if (this.swiperProgressBar && this.swiper) {
        if (this.swiper.slides.length <= this.swiper.params.slidesPerView) {
          this.swiperProgressBar.closest('.yg-swiper-progress-container').style.display = 'none';
        } else {
          this.swiperProgressBar.closest('.yg-swiper-progress-container').style.display = 'flex';
        }
      }
    }

    updateSwiperProgress() {
      if (this.swiperProgressBar && this.swiper) {
        const progress = ((this.swiper.activeIndex + 1) / this.totalSlides) * 100;
        console.log('progress', progress);

        this.swiperProgressBar.style.width = `${progress}%`;
      }
    }

    updateVideoProgressFn(event) {
      const video = event.target;
      const slide = video.closest('.swiper-slide');
      const progressBar = slide?.querySelector('.yg-video-progress-bar');

      if (progressBar && video.duration) {
        const progress = (video.currentTime / video.duration) * 100;
        progressBar.style.width = `${progress}%`;
      }
    }
  }

  if (!window.customElements.get('yg-video-list')) {
    window.customElements.define('yg-video-list', YGVideoList);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["yg-video-tab"] && !Shopify.designMode) return;
  try {
    
  (() => {
    class YGVideoSwiper extends HTMLElement {
      constructor() {
        super();
        this.swiper = null;
        this.currentIndex = 0;
      }

      connectedCallback() {
        this.init();
      }

      disconnectedCallback() {
        if (this.swiper) {
          this.swiper.destroy(true, true);
          this.swiper = null;
        }
      }

      init() {
        // 等待 Swiper 库加载
        if (typeof Swiper === 'undefined') {
          setTimeout(() => this.init(), 100);
          return;
        }

        const swiperEl = this.querySelector('.yg-progress-swiper');
        const tabItems = this.querySelectorAll('.yg-tab-item');
        const descItems = this.querySelectorAll('.yg-video-desc');
        const tabWrapper = this.querySelector('.yg-tab-wrapper');

        if (!swiperEl || !tabItems.length) {
          return;
        }

        // 初始化 Swiper
        this.swiper = new Swiper(swiperEl, {
          slidesPerView: 1,
          effect: 'fade',
          fadeEffect: {
            crossFade: true,
          },
          speed: 400,
          on: {
            slideChange: (swiper) => {
              this.updateActiveStates(swiper.activeIndex);
            },
          },
        });

        // 绑定 tab 点击事件
        tabItems.forEach((tab, index) => {
          tab.addEventListener('click', () => {
            if (this.swiper) {
              this.swiper.slideTo(index);
            }
          });
        });

        // 自动滚动 tab 到可见区域
        const scrollTabIntoView = (index) => {
          const activeTab = tabItems[index];
          if (!activeTab || !tabWrapper) return;

          const wrapperRect = tabWrapper.getBoundingClientRect();
          const tabRect = activeTab.getBoundingClientRect();
          const scrollLeft = tabWrapper.scrollLeft;
          const tabLeft = tabRect.left - wrapperRect.left + scrollLeft;
          const tabCenter = tabLeft + tabRect.width / 2;
          const wrapperCenter = wrapperRect.width / 2;

          tabWrapper.scrollTo({
            left: tabCenter - wrapperCenter,
            behavior: 'smooth',
          });
        };

        // 监听窗口大小变化
        let resizeTimer;
        window.addEventListener('resize', () => {
          clearTimeout(resizeTimer);
          resizeTimer = setTimeout(() => {
            scrollTabIntoView(this.currentIndex);
          }, 150);
        });

        // 初始滚动
        setTimeout(() => scrollTabIntoView(0), 100);
      }

      updateActiveStates(index) {
        this.currentIndex = index;

        // 更新 tab 激活状态
        const tabItems = this.querySelectorAll('.yg-tab-item');
        tabItems.forEach((tab, i) => {
          if (i === index) {
            tab.classList.add('active');
          } else {
            tab.classList.remove('active');
          }
        });

        // 更新描述激活状态
        const descItems = this.querySelectorAll('.yg-video-desc');
        descItems.forEach((desc, i) => {
          if (i === index) {
            desc.classList.add('active');
          } else {
            desc.classList.remove('active');
          }
        });

        // 滚动 tab 到可见区域
        const tabWrapper = this.querySelector('.yg-tab-wrapper');
        const activeTab = tabItems[index];
        if (activeTab && tabWrapper) {
          const wrapperRect = tabWrapper.getBoundingClientRect();
          const tabRect = activeTab.getBoundingClientRect();
          const scrollLeft = tabWrapper.scrollLeft;
          const tabLeft = tabRect.left - wrapperRect.left + scrollLeft;
          const tabCenter = tabLeft + tabRect.width / 2;
          const wrapperCenter = wrapperRect.width / 2;

          tabWrapper.scrollTo({
            left: tabCenter - wrapperCenter,
            behavior: 'smooth',
          });
        }
      }
    }

    if (!customElements.get('yg-video-swiper')) {
      customElements.define('yg-video-swiper', YGVideoSwiper);
    }
  })();

  } catch(e) { console.error(e); }
})();
})();
